import { IonInput, IonItem, IonList, IonText, IonThumbnail } from "@ionic/react";
import { useState } from "react";
import { PersonView } from "./userTypes";

import BlueskyLogo from '../icons/svg/social/bluesky-logo.svg';

import styles from "./SocialMedia.module.css";

interface SocialMediaProps {
  person: PersonView;
  showIconOnly?: boolean;
}

export default function SocialMedia({ person, showIconOnly }: SocialMediaProps) {
  const personInfo = person.person;

  const [blueskyUsername, setBlueskyUsername] = useState("");
  
  return (
    <>
      <div className={styles.container}>        
        <IonList inset>
          {personInfo.social_bluesky
            ? (
              <IonItem
                href={`https://bsky.app/profile/${personInfo.social_bluesky}`}
                detail={false}
                onClick={(e) => e.stopPropagation()}
              >
                <IonThumbnail className={styles.serverThumbnail} slot="start">
                  <img
                    className={styles.serverImg}
                    src={BlueskyLogo}
                  />
                </IonThumbnail>
                {!showIconOnly
                  ? (
                    <IonInput
                      labelPlacement="stacked"
                      value={blueskyUsername}
                      onIonInput={(e) => setBlueskyUsername(e.detail.value || "")}
                    >
                      <IonText color="medium" slot="start">
                        {blueskyUsername ? `@${blueskyUsername}` : `@${personInfo.social_bluesky}`}
                      </IonText>
                    </IonInput>
                  )
                  : null
                }
              </IonItem>
            )
            : <></>
          }
        </IonList>
        {}
      </div>
    </>
  );
}
